"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RestorationLoader_module_scss_1 = __importDefault(require("./RestorationLoader.module.scss"));
function RestorationLoader() {
    return (react_1.default.createElement("div", { className: RestorationLoader_module_scss_1.default.skeleton },
        react_1.default.createElement("div", { className: RestorationLoader_module_scss_1.default.headline },
            react_1.default.createElement("div", null)),
        react_1.default.createElement("div", { className: RestorationLoader_module_scss_1.default.credentials },
            react_1.default.createElement("div", { className: RestorationLoader_module_scss_1.default.inputTitle }),
            react_1.default.createElement("div", { className: RestorationLoader_module_scss_1.default.input }),
            react_1.default.createElement("div", { className: RestorationLoader_module_scss_1.default.footer }))));
}
exports.default = RestorationLoader;
